/* eslint-disable array-callback-return */
/* eslint-disable no-lone-blocks */
/* eslint-disable indent */
import React from "react";
import PropTypes from "prop-types";

import { isWeekend } from "../../../constant/helper/helper";
import {
  CREATED_AS_COLOR,
  CREATED_AS_STATUS
} from "../../../constant/constant";

const ShowDateList = ({ dayList }) => {
  return dayList.map((dateValue, dateIndex) => {
    const weekendOrNot = isWeekend(dateValue.Date);

    return (
      <td
        key={dateIndex}
        className={
          weekendOrNot
            ? "table-action text-center bg-danger-lighten"
            : "table-action text-center"
        }
      >
        <span className={CREATED_AS_COLOR[dateValue.createdAs]}>
          {CREATED_AS_STATUS[dateValue.createdAs]}
        </span>
        <br />
        <span className={CREATED_AS_COLOR[dateValue.createdAs]}>
          {dateValue.inTime}
        </span>
        -
        <span className={CREATED_AS_COLOR[dateValue.createdAs]}>
          {dateValue.outTime}
        </span>
        <br />
        <span className={CREATED_AS_COLOR[dateValue.createdAs]}>
          {dateValue.duration}
        </span>
      </td>
    );
  });
};

ShowDateList.propTypes = {
  dayList: PropTypes.array.isRequired
};

export default ShowDateList;
